var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#72080A",
    d: "M9.923 2.52a.2.2 0 0 1 .079-.02q.045.001.079.02c.019.01.043.03.068.071l8.571 14.584a.22.22 0 0 1 .003.229.2.2 0 0 1-.068.075.14.14 0 0 1-.082.021H1.431a.14.14 0 0 1-.082-.02.2.2 0 0 1-.068-.076.22.22 0 0 1 .002-.23L9.855 2.592a.2.2 0 0 1 .068-.071m1.304-.562a1.414 1.414 0 0 0-2.45 0L.206 16.541c-.572.972.114 2.209 1.225 2.209h17.142c1.11 0 1.796-1.237 1.225-2.209z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#72080A",
    d: "M8.752 15a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M8.874 7.494a1.131 1.131 0 1 1 2.252 0l-.439 4.384a.69.69 0 0 1-1.374 0z"
  })));
};
export default SvgAlert;